module.exports = __webpack_public_path__ + "img/background-menu.f15e781c.jpg";